import * as yup from "yup";
import Translate from "../../../../../translation/utils/translateFunction";

export const AddGroupSchema = () => {
  const schema = yup.object().shape({
    groupName: yup.string().trim().required(Translate("group:groupSubjectError")),
  });
  return schema;
};
